module.exports = __webpack_public_path__ + "static/media/hero.59df2df6.png";